import { ArrowForward } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import React from "react";

export default function GenreBar({ genre }) {
    if (!genre) {
        return null;
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1, backgroundColor: "grey.50", borderRadius: 1 }}>

            {/* Parent Genre (if exists) */}
            {genre.parentGenre && (
                <>
                    <Chip
                        label={genre.parentGenre.name}
                        size="small"
                        variant="outlined"
                        color="secondary"
                        sx={{ fontSize: "0.75rem" }}
                    />
                    <ArrowForward fontSize="small" color="action" />
                </>
            )}

            {/* Current Genre */}
            <Chip
                label={genre.name}
                size="small"
                color="primary"
                sx={{ fontSize: "0.75rem", fontWeight: "medium" }}
            />

            {/* Genre Description (if exists) */}
            {genre.description && (
                <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    ({genre.description})
                </Typography>
            )}
        </Box>
    );
}
